import { InputElementFragment } from "__generated__/graphqlUnauthenticated";
import { hideTypes } from "./PreviewFormUI";
import * as Yup from "yup";

export const generateValidationSchema = (elements: InputElementFragment[]) => {
  const schemaObject = {};

  elements.forEach((element) => {
    if (
      element.__typename === "InputElement" &&
      element.required &&
      !hideTypes.includes(element.displayAs || "") &&
      !element.hidden
    ) {
      schemaObject[element.id || ""] = Yup.string().required(
        `Please enter ${element.field.toLowerCase()}`,
      );
    }
  });

  return Yup.object().shape(schemaObject);
};
